import { useEffect, useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
  ConfigProvider,
  Space,
  Table,
  Tag,
  Input,
  Flex,
  Modal,
  InputNumber,
  Button,
  Alert,
  message,
  DatePicker,
  Select,
} from "antd";
const { TextArea } = Input;

// import { Modal } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
// import { useState } from "react";

import dayjs from "dayjs";
import formatRupiah from "@/utils/FormatRupiah";

import { ICONS } from "@/assets";
import CustomModal from "@/components/CustomModal";
import ModalAddInhouse from "@/components/CustomModals/ModalAddInhouse";

import { ApplicationInquiry } from "../../../library/FormColumn";

import { API, URL } from "../../../config/api";

import ButtonExportPDF from "@/components/ButtonExportPDF";
import ButtonExportExcel from "@/components/ButtonExportExcel";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { createStyles } from "antd-style";
import { Link, useNavigate } from "react-router-dom";
import useRoleAccess from "@/hooks/useRoleAccess";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const InhousePage = () => {
  const { isViewer } = useRoleAccess();
  const [branch, setBranch] = useState(null);
  const [status, setStatus] = useState(null);
  const [dateRange, setDateRange] = useState(null); // [start, end]

  const branchOptions = [
    { value: "jakarta", label: "Jakarta" },
    { value: "bandung", label: "Bandung" },
    { value: "surabaya", label: "Surabaya" },
  ];

  const statusOptions = [
    { value: "CRA", label: "Credit Review" },
    { value: "APPV-1", label: "Approval 1" },
    { value: "APPV-2", label: "Approval 2" },
    { value: "APPV-3", label: "Approval 3" },
    { value: "FA", label: "Final Approval" },
    { value: "Rejected", label: "Rejected" },
  ];

  const [isReturnModalOpen, setIsReturnModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [returnValue, setReturnValue] = useState("");

  const { styles } = useStyle();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  // useEffect(() => {
  //   const fetchOptions = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await API.get(URL.MASTER_ACC);
  //       const data = res.data.data;

  //       // Transformasi data agar sesuai format options Select
  //       const formattedOptions = data.map((item) => ({
  //         value: item.id,
  //         label: `${item.nameAcc} - ${item.noAcc}`,
  //         noAcc: item.noAcc,
  //         nameAcc: item.nameAcc,
  //       }));

  //       setOptions(formattedOptions);
  //     } catch (error) {
  //       console.error("Error fetching options:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchOptions();
  // }, []);

  const handleChange = (value, name) => {
    console.log("value change", value);
    console.log("name change", name);
    setSelectedData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedData(null);
    setIsAddOpen(false);
    setIsEditOpen(false);
  };

  useEffect(() => {
    console.log("type", modalType);
  }, [modalType]);

  const handleModal = (type, record) => {
    setModalType(type);
    setSelectedData(record); // Simpan data baris yang dipilih
    console.log("record", record);
  };

  const openAddModal = () => {
    setModalType(null); // Set modal untuk Add
    setIsEditOpen(false);
    setIsAddOpen(true);
    setSelectedData(null);
  };

  const openEditModal = (data) => {
    setModalType(null); // Set modal untuk Edit
    setIsAddOpen(false);
    setIsEditOpen(true);

    setSelectedData(data);
  };

  const handleSubmit = async (values) => {
    console.log("isAddOpen", isAddOpen);
    console.log("Form Submitted:", values);

    try {
      // await API.post(URL.TRX_INHOUSE + "/add", values);

      setSelectedData(null); // Update data for Edit modal
      getData();
      successMsg();
      closeModal();
      return;
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Gagal menambahkan data!");
    }
  };

  // const getData = async () => {
  //   try {
  //     // const res = await API.get(URL.TRX_INHOUSE);
  //     // setData(res.data.data);
  //     setData([{ id: 1 }]);
  //   } catch (error) {
  //     console.error("Error fetching account data:", error);
  //     errorMsg();
  //   }
  // };

  // const getData = async () => {
  //   try {
  //     const params = {
  //       branch,
  //       status,
  //       startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
  //       endDate: dateRange?.[1]?.format("YYYY-MM-DD"),
  //     };

  //     // const res = await API.get(URL.TRX_INHOUSE, { params });
  //     // setData(res.data.data);

  //     console.log("Fetching data with filters:", params);
  //     // setData([{ id: 1, tgl: "2024-06-12", noAcc: "001", nameAcc: "Kas", keterangan: "Test", kategori: "Debit", amount: 100000 }]);
  //     setData([
  //       {
  //         id: 1,
  //         nama: "Musyaffa Nur Ihsanuddin",
  //         nik: "3278030402910003",
  //         alamat: "Cilebut",
  //         pefindo: "https://google.com",
  //         slik: "https://google.com",
  //         is_survey: 1,
  //         // pasangan: {
  //         //   namapasangan: "Azzahra",
  //         // },
  //       },
  //     ]);
  //   } catch (error) {
  //     console.error("Error fetching account data:", error);
  //     errorMsg();
  //   }
  // };

  const getData = async () => {
    setLoading(true);
    try {
      const API_BASE_URL = import.meta.env.VITE_BASE_URL2;
      const res = await fetch(`${API_BASE_URL}/api/getlist`);
      const json = await res.json();

      // Gabungkan seluruh array di dalam object menjadi satu array
      const mergedData = Object.values(json)
        .filter(Array.isArray) // hanya ambil yang array
        .flat(); // gabung array menjadi satu

      setData(mergedData);
    } catch (error) {
      console.error("Error fetching pemohon list:", error);
      errorMsg();
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   getData();
  // }, []);

  useEffect(() => {
    getData();
  }, [branch, status, dateRange]);

  console.log("selectedData", selectedData);

  const optionsKategori = [
    { value: "Debit", label: "Debit" },
    { value: "Kredit", label: "Kredit" },
  ];

  const actionColumn2 = {
    title: "Action",
    key: "action",
    fixed: "right",
    align: "center",
    // width: 100,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/approval/detail/${record.application_id}/${record.nik}`}>
          <img src={ICONS.FaDetail} alt="View" />
        </Link>

        <button
          onClick={() => handleReturn(record)}
          style={{ background: "none", border: "none", cursor: "pointer" }}
        >
          <img src={ICONS.FaReturn} alt="Return" />
        </button>

        {/* <button onClick={() => openEditModal(record)}>
          <img src={ICONS.FaEdit} alt="Edit" />
        </button>

        <button onClick={() => handleModal("delete", record)}>
          <img src={ICONS.FaTrash} alt="Delete" />
        </button> */}
      </Space>
    ),
  };

  const actionColumn = {
    title: "Action",
    key: "action",
    fixed: "right",
    align: "center",
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/approval/detail/${record.application_id}/${record.nik}`}>
          <Button
            icon={<img src={ICONS.FaDetail} width={16} height={16} />}
            size="small"
          />
        </Link>

        <Button
          icon={<RollbackOutlined />}
          size="small"
          disabled={isViewer}
          onClick={() => {
            setSelectedRecord(record);
            setReturnValue("");
            setIsReturnModalOpen(true);
          }}
        />
      </Space>
    ),
  };

  const handleSubmitReturn = async () => {
    if (!returnValue) {
      message.warning("Silakan pilih alasan return terlebih dahulu");
      return;
    }
    const API_BASE_URL = import.meta.env.VITE_BASE_URL2;

    const payload = {
      application_id: selectedRecord.application_id,
      reason: returnValue,
    };

    console.log("RETURN PAYLOAD:", payload);

    try {
      await API.post(`${API_BASE_URL}/api/approval/return`, payload);

      message.success("Application berhasil di-return");

      setIsReturnModalOpen(false);
      setReturnValue("");
      setSelectedRecord(null);

      // refresh data table
      getData(); // atau refetch()
    } catch (error) {
      console.error(error);
      message.error("Gagal return application");
    }
  };

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  //   const runningNumberColumn = {
  //   title: "No",
  //   key: "no",
  //   render: (text, record, index) =>
  //     (pagination.current - 1) * pagination.pageSize + index + 1,
  //   width: 50,
  //   align: "center",
  // };

  const runningNumberColumn = {
    title: "Nox",
    key: "no",
    render: (text, record, index) =>
      (pagination.current - 1) * pagination.pageSize + index + 1,
    width: 50,
    align: "center",
  };

  const extendedColumn = [
    runningNumberColumn,
    ...ApplicationInquiry.columns,
    actionColumn,
  ];

  const [messageApi, contextHolder] = message.useMessage();

  const successMsg = () => {
    messageApi.open({
      type: "success",
      content: "Success create data",
    });
  };
  const successUpdateMsg = () => {
    messageApi.open({
      type: "success",
      content: "Success update data",
    });
  };

  const errorMsg = () => {
    messageApi.open({
      type: "error",
      content: "Data is empty",
    });
  };

  const successMsgDelete = () => {
    messageApi.open({
      type: "success",
      content: "Success delete data",
    });
  };

  const exportPDF = () => {
    // console.log(data);
    if (data != "") {
      const doc = new jsPDF();

      // Ambil header dari kolom tabel Ant Design
      const headers = ColumnTransaksiInhouse.columns.map((col) => col.title);

      // Ambil data dari `dataSource`
      const body = data.map((row) =>
        // ColumnTransaksiInhouse.columns.map((col) => row[col.dataIndex])
        ColumnTransaksiInhouse.columns.map((col) =>
          col.dataIndex === "amount"
            ? formatRupiah(row[col.dataIndex])
            : row[col.dataIndex],
        ),
      );

      // Gunakan `autoTable` untuk membuat PDF
      doc.autoTable({
        head: [headers],
        body: body,
      });

      // Simpan file PDF
      doc.save("Laporan Keuangan.pdf");
    } else {
      errorMsg();
      console.log("error");
    }
  };

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const formattedDate = date.format("MMM-YY");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(getMonthName);

    // Tambahkan header utama
    worksheet.mergeCells("A1:F1");
    const header1 = worksheet.getCell("A1");
    header1.value = "TRANSAKSI INHOUSE";
    header1.font = { bold: true, size: 24 };
    header1.alignment = { horizontal: "center", vertical: "middle" };
    header1.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header1.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.mergeCells("A2:H2");
    const header3 = worksheet.getCell("A2");
    header3.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ffffff" }, // white background
    };

    // Tambahkan sub-header dengan tanggal
    worksheet.mergeCells("A3:F3");
    const header2 = worksheet.getCell("A3");
    header2.value = formattedDate;
    header2.font = { bold: true, size: 32 };
    header2.alignment = { horizontal: "center", vertical: "middle" };
    header2.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header2.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.getRow(4).height = 25;

    // Tambahkan header kolom
    const headers = [
      "TANGGAL",
      "NOMOR AKUN",
      "NAMA AKUN",
      "KETERANGAN",
      "KATEGORI",
      "AMOUNT",
    ];
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
      cell.value = header;
      cell.font = { bold: false, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });

    data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
      row.getCell(1).value = item.tgl;
      row.getCell(2).value = item.noAcc;
      row.getCell(3).value = item.nameAcc;
      row.getCell(4).value = item.keterangan;
      row.getCell(5).value = item.kategori;
      row.getCell(6).value = item.amount;

      row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(5).alignment = { horizontal: "center", vertical: "middle" };

      // Format untuk nilai angka (Debet, Kredit, Saldo)
      row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

      const capitalizeText = (text) =>
        text.replace(/\b\w/g, (char) => char.toUpperCase());

      row.getCell(5).value = capitalizeText(row.getCell(5).value);
      row.getCell(5).font = { bold: true, size: 12 };

      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      // Loop through cells 1 to 5 and apply the border style
      for (let i = 1; i <= headers.length; i++) {
        row.getCell(i).border = borderStyle;
      }
    });

    // Atur lebar kolom
    worksheet.columns = [
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Laporan Transaksi Inhouse.xlsx`);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const returnOptions = [
    // { value: "SELECT", label: "Pilih bucket return" },
    { value: "CRA", label: "Credit Review (CRA)" },
    { value: "APPV-1", label: "Approval 1" },
    { value: "APPV-2", label: "Approval 2" },
    { value: "APPV-3", label: "Approval 3" },
  ];

  return (
    <div>
      <Modal
        title="Return Application"
        open={isReturnModalOpen}
        onCancel={() => setIsReturnModalOpen(false)}
        onOk={handleSubmitReturn}
        okText="Submit"
      >
        <p>
          <strong>Application ID:</strong> {selectedRecord?.application_id}
        </p>

        <Select
          placeholder="Pilih bucket return"
          style={{ width: "100%" }}
          options={returnOptions}
          value={returnValue}
          onChange={(value) => setReturnValue(value)}
          allowClear
        />

        {/* <Input
    placeholder="Masukkan alasan return"
    value={returnValue}
    onChange={(e) => setReturnValue(e.target.value)}
  /> */}
      </Modal>
      {contextHolder}

      <h1 className="text-4xl font-semibold mb-8">LIST FINAL APPROVAL</h1>
      <div className="flex gap-4">
        <ButtonExportPDF onClick={exportPDF} />
        <ButtonExportExcel onClick={exportToExcel} />
      </div>
      <div className="flex justify-between">
        {
          /* <Button
          type="primary"
          size="large"
          // onClick={() => handleModal("add", {})}
          onClick={() => openAddModal()}
          // onClick={() => setModalType("add")}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button> */

          <div className="flex flex-wrap gap-4 mb-4">
            {/* <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Cabang"
              options={branchOptions}
              value={branch}
              onChange={(val) => setBranch(val)}
            /> */}

            {/* <DatePicker.RangePicker
              format="DD/MM/YYYY"
              value={dateRange}
              onChange={(val) => setDateRange(val)}
              style={{ width: 300 }}
            /> */}

            <Input
              allowClear
              placeholder="Cari application ID / NIK / Nama"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: 300 }}
            />
            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Status"
              options={[
                { value: "FA", label: "Final Approval" },
                { value: "REJECTED", label: "Rejected" },
              ]}
              value={status}
              onChange={(val) => setStatus(val)}
            />

            {/* <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Status"
              options={statusOptions}
              value={status}
              onChange={(val) => setStatus(val)}
            /> */}

            <Button
              type="primary"
              onClick={() => getData()}
              className="bg-blue-600 text-white"
            >
              Filter
            </Button>
          </div>
        }
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          className={styles.customTable}
          columns={extendedColumn}
          loading={loading}
          dataSource={data.filter((item) => {
            const term = searchTerm.toLowerCase();

            const matchSearch =
              item.application_id?.toLowerCase().includes(term) ||
              item.nik?.toLowerCase().includes(term) ||
              item.nama?.toLowerCase().includes(term);

            // kalau status dropdown dipilih → filter sesuai status
            const matchStatus = status
              ? item.status?.toLowerCase() === status.toLowerCase()
              : true;

            // default: hanya FA dan REJECTED yang bisa masuk list
            const allowedStatus = ["FA", "REJECTED"];
            const isAllowed = allowedStatus.includes(item.status);

            return matchSearch && matchStatus && isAllowed;
          })}
        />
      </ConfigProvider>

      {/* <ModalAddInhouse
        key={isAddOpen ? "add" : "hidden"}
        visible={isAddOpen}
        onClose={closeModal}
        title="Tambah Transaksi"
        // content={renderContent()}
        onSave={handleSubmit}
      /> */}
    </div>
  );
};

export default InhousePage;
